import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(6),
  },
}));

export default useStyles;
